import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import { Link } from 'react-router-dom';
import { TextField } from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { isSuperAdmin } from '../../api/services/AuthService';
import Button from '@mui/material/Button';
import BilheteService from '../../api/services/BilheteService';
import EmpresaService from '../../api/services/EmpresaService';
//import { getCodEmpUser } from '../../api/services/AuthService';
import moment from 'moment'
import Fab from '@mui/material/Fab';
import Backdrop from '../../backdrop/BackDrop';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CardHeaderFilterSearch from '../../main/CardHeaderFilterSearch';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { motion } from "framer-motion";
import Tooltip from '@mui/material/Tooltip';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import InputMask from 'react-input-mask'
import BackDrop from '../../backdrop/BackDrop';


import { DataGrid, ptBR } from '@mui/x-data-grid';

const LayoutBilhete = styled.div(props => ({
  display: props.display,
  backgroundColor: 'bold',
  width: '95%',
  height: '880px',
  top: '80px',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
  marginTop: '100px'
}));

const DialogTitleCliente = styled(DialogTitle)`   
    color:#041E42;
`

const LinkSolicitarReembolso = styled(Link)`
  float: right;
`
const Titulo = styled(Typography)`
  color:#9A294B;
  font-weight:bold;
  width:100%;
  margin-botton:30px;
`

const MsgTitulo = styled(Typography)`
    color:#9A294B;
    font-weight:bold;
    float: left;
`
const Header = styled(Box)`   
    margin-top:10px;
    width:100%;
    height:50px;
`
const Tabela = styled.div`
  height: 600px;
  width: 100%;
  margin-top:10px;
`
const TabelaModal = styled.div`
    height: 300px;
    overflow: auto;
    width: 100%;
    margin-top:10px;
`
const bilheteService = new BilheteService();
const empresaService = new EmpresaService();

const PesquisarBilhetes = (props) => {
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  //let navigate = useNavigate();
  const [bilhete, setBilhete] = useState("");
  const [localizador, setLocalizador] = useState("");
  const [open, setOpen] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [backdropDialog, setBackdropDialog] = useState(false)
  const [nomeEmpresa, setNomeEmpresa] = useState("");
  const [codigoEmpresa, setCodigoEmpresa] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [codigoEmpresaSelecionada, setCodigoEmpresaSelecionada] = useState();
  const [cnpjEmpresa, setCnpjEmpresa] = useState("");
  const [cpfEmpresa, setCpfEmpresa] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [empresaSelecionada, setEmpresaSelecionada] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [tipoSnack, setTipoSnack] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setEmpresa(localStorage.getItem("empresa"));
    setCodigoEmpresaSelecionada(localStorage.getItem("codigoEmpresaSelecionada"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selecionarEmpresa = () => {
    if (!empresaSelecionada) {
      setErrorMessage('Nenhum Cliente Selecionado!');
      setOpenSnack(true);
      setTipoSnack("warning")
    } else {
      setEmpresa(empresaSelecionada.codemp + " - " + empresaSelecionada.nome);
      setCodigoEmpresaSelecionada(empresaSelecionada.codemp);
      localStorage.setItem("empresa", empresaSelecionada.codemp + " - " + empresaSelecionada.nome);
      localStorage.setItem("codigoEmpresaSelecionada", empresaSelecionada.codemp)
      setOpenDialog(false);
      setOpenSnack(true);
      setTipoSnack("success")
      setErrorMessage('Empresa ' + empresaSelecionada.nome + ' selecionada!');
    }
  }

  const findEmpresas = () => {
    if (validarListagemCliente()) {
      setBackdropDialog(true);
      empresaService.listarEmpresas({
        codemp: codigoEmpresa === '' ? null : codigoEmpresa,
        nome: nomeEmpresa === '' ? null : nomeEmpresa,
        cnpj: cnpjEmpresa === '' ? null : cnpjEmpresa.replace(/[^\d]+/g, ''),
        cpf: cpfEmpresa === '' ? null : cpfEmpresa.replace(/[^\d]+/g, ''),
      }).then(response => {
        setEmpresas(response.data);
      }).catch(erro => {
        console.log('Error name: ', erro.name)
        console.log('Error message: ', erro.message)
        console.log('Error stack: ', erro.stack)
      }).finally(() => {
        handleClose();
        setBackdropDialog(false);
      })
    }
  }


  const validarListagemCliente = () => {
    let retorno = true;
    if (!nomeEmpresa && !codigoEmpresa && !cnpjEmpresa && !cpfEmpresa) {
      setErrorMessage("Preencha pelo menos um campo de filtro para realizar a pesquisa de clientes!");
      setOpenSnack(true);
      setTipoSnack("warning")

      retorno = false;
    }
    return retorno;
  }

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  async function handleClose() {
    setOpen(false);
    return open;
  };

  async function handleToggle() {
    setOpen(true);
    return open;
  };

  const handleCloseDialog = () => {
    setEmpresaSelecionada("");
    setCodigoEmpresa("");
    setEmpresa("");
    setEmpresas([]);
    setOpenDialog(false);
  };

  const filterRequest = () => {
    return {
      numtkt: bilhete === '' ? null : bilhete,
      loc: localizador === '' ? null : localizador,
    };
  }

    const buscarBilhetes = () => {
      handleToggle();
      if ((bilhete === '' || bilhete === null) && (localizador === '' || localizador === null)) {
        handleClose();
        setErrorMessage("Por favor, utilize ao menos uma opção de filtro, entre com Nº Bilhete e/ou Localizador, para pesquisar bilhetes!");
        setTipoSnack("warning")
        setOpenSnack(true);
      } else {
        bilheteService.listar((isSuperAdmin) 
          ? Object.assign({}, filterRequest(), { empfat: codigoEmpresaSelecionada }) 
          : filterRequest())
        .then(response => {
          console.log(response.data)
          setRows(response.data);
        }).catch(erro => {
          //setError(true);
        }).finally(() => {
          handleClose();
        })
      }
    };

    const clearModal = () => {
      setEmpresaSelecionada("");
      setCodigoEmpresa("");
      setEmpresas([]);
      setNomeEmpresa("");
      setCnpjEmpresa("");
      setCpfEmpresa("");
    }

    /**    const sessionExpired = () => {
      navigate('/login', { state: { expired: true } })
    }*/ 

    const clear = () => {
      handleToggle();
      const exec = () => {
        setBilhete("");
        setLocalizador("");
        setRows([]);
        setSelectionModel([]);
        handleClose();
        localStorage.removeItem("empresa");
        localStorage.removeItem("codigoEmpresaSelecionada")
        setEmpresa("");
        setCodigoEmpresaSelecionada("");
        clearModal();
      }

      setTimeout(exec, 500);
    }

    async function showSolicitacao() {
        await handleToggle();
        const exec = () => {
          const bilhetes = [];
          let cadCartao = false;
          // eslint-disable-next-line array-callback-return
          selectionModel.map(function (tktSelected) {
            // eslint-disable-next-line array-callback-return
            rows.map(function (tkt) {
              if (tkt.numtkt === tktSelected) {
                bilhetes.push(tkt);
                if (tkt.cartao) {
                  cadCartao = true;
                }
              }
            })
          });

          props.setCadastrarCartao(cadCartao);
          props.selecionados(bilhetes);
          props.setViewSearchBilhetes('none');
          props.setViewSearchSolicitacao('block');

          handleClose();
        }
        setTimeout(exec, 500);
    }

    const handleCloseSnack = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpenSnack(false);
    };

    const columns = [
      { field: 'numtkt', headerName: 'Ticket', flex: 1, minWidth: 150 },
      {
        field: 'dataemi', headerName: 'Dt. Emissão', flex: 1, minWidth: 165,
        renderCell: (params) => {
          return moment(params.value).format('DD/MM/YYYY');
        },
      },
      { field: 'loc', headerName: 'Localizador', flex: 1, minWidth: 160 },
      {
        field: 'cartao', headerName: 'Cartão', flex: 1, minWidth: 100, renderCell: (params) => {
          return params.value !== null && params.value === true ? 'Sim' : ' Não ';
        },
      },
      { field: 'pax', headerName: 'Passageiro', flex: 1, minWidth: 320 },
      { field: 'stat', headerName: 'Tipo Pax', flex: 1, minWidth: 100 },
      { field: 'codcia', headerName: 'Cia', flex: 1, minWidth: 80 },
      { field: 'rota', headerName: 'Rota', flex: 1, minWidth: 180 },
      {
        field: 'dataemb', headerName: 'Data Voo', flex: 1, minWidth: 150,
        renderCell: (params) => {
          return moment(params.value).format('DD/MM/YYYY');
        },
      },
    ];

    const [rows, setRows] = useState([]);
    return (
      <>
        <motion.div
          className='reembolso'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}>

          <Backdrop onOpen={open}></Backdrop>
          <LayoutBilhete className="container" display={props.viewSearchBilhetes}>
            <Header>
              <Titulo>
                <MsgTitulo variant="h5" gutterBottom component="div">LISTAGEM DE BILHETES</MsgTitulo>
                <LinkSolicitarReembolso loading to='/reembolso' title="Listar Reembolsos Solicitados">
                  <Fab sx={{ zIndex: 0, marginRight: 0 }} color="primary" aria-label="add" size="small">
                    <ListAltIcon />
                  </Fab>
                </LinkSolicitarReembolso>
              </Titulo>
            </Header>
            <Card sx={{ minWidth: 800, backgroundColor: "#F5F5F5", flexGrow: 1, marginTop: 1 }}>
              <CardContent>
                <CardHeaderFilterSearch />
                <Box component="form">
                  <TextField
                    id="bilhete"
                    sx={{ width: 160, backgroundColor: "#FFFF" }}
                    label="Nº Bilhete"
                    type="text"
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={bilhete}
                    onChange={(event) => {
                      setBilhete(event.target.value);
                    }}
                  />
                  <TextField
                    id="localizador"
                    sx={{ width: 130, marginLeft: 3, backgroundColor: "#FFFF" }}
                    label="Localizador"
                    type="text"
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={localizador}
                    onChange={(event) => {
                      setLocalizador(event.target.value);
                    }}
                  />
                  {isSuperAdmin() ?
                    <TextField
                      id="empresaAdmin"
                      sx={{ width: 500, backgroundColor: "#FFFF", marginLeft: 2.5 }}
                      label="Empresa"
                      type="text"
                      fullWidth
                      margin="normal"
                      variant="outlined"
                      size="small"
                      disabled
                      value={empresa}
                      onChange={(event) => {
                        setEmpresa(event.target.value.replace(/[^0-9.]/g, ''));
                      }}
                    />
                    : null}
                  {isSuperAdmin() ?
                    <Tooltip title="Clique Para Pesquisar Agência!">
                      <Fab onClick={handleClickOpen} sx={{ m: 1, marginTop: 2, marginLeft: 2 }} variant="contained" color="primary" aria-label="add" size="small">
                        <AddBusinessIcon />
                      </Fab>
                    </Tooltip>
                    : null}
                  <Button sx={{ width: 170, marginLeft: 2.5, marginTop: 2.2 }} onClick={buscarBilhetes} color="primary" variant="contained">Listar Bilhetes</Button>
                  <Button sx={{ width: 120, marginLeft: 2.5, marginTop: 2.2 }} onClick={clear} variant="contained" color="primary">Limpar</Button>
                  <Button sx={{ width: 140, marginLeft: 2.5, marginTop: 2.2 }} onClick={showSolicitacao} color="primary" disabled={!selectionModel.length > 0} variant="contained">Solicitar</Button>
                </Box>
              </CardContent>
            </Card>
            <Tabela>
              <DataGrid
                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                rows={rows}
                getRowId={(row) => row.numtkt}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                pagination
                checkboxSelection
                isRowSelectable={(params) => params.row.alreadyRequest}
                onSelectionModelChange={(newSelectionModel) => {
                  setSelectionModel(newSelectionModel);
                }}
                selectionModel={selectionModel}
              />
            </Tabela>
          </LayoutBilhete>
          <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
            <Alert onClose={handleCloseSnack} severity={tipoSnack} sx={{ width: '100%' }}>
              {errorMessage}
            </Alert>
          </Snackbar>
        </motion.div>
        <Dialog maxWidth="lg" fullWidth open={openDialog} onClose={handleCloseDialog}>
          <BackDrop onOpen={backdropDialog}></BackDrop>
          <DialogTitleCliente>PESQUISA DE CLIENTES</DialogTitleCliente>
          <DialogContent >
            <TextField
              autoFocus
              margin="dense"
              sx={{ width: 100 }}
              id="codigo"
              label="Código"
              fullWidth
              variant="standard"
              value={codigoEmpresa}
              onChange={(event) => {
                setCodigoEmpresa(event.target.value);
              }}
            />
            <TextField
              autoFocus
              margin="dense"
              id="empresa"
              label="Empresa"
              sx={{ width: 400, marginLeft: 2 }}
              fullWidth
              variant="standard"
              value={nomeEmpresa}
              onChange={(event) => {
                setNomeEmpresa(event.target.value);
              }}
            />
            <InputMask mask="99.999.999/9999-99" value={cnpjEmpresa} onChange={(event) => {
              setCnpjEmpresa(event.target.value);
            }}>
              {
                inputProps => (
                  <TextField
                    autoFocus
                    margin="dense"
                    id="cnpj"
                    sx={{ width: 200, marginLeft: 2 }}
                    label="CNPJ"
                    fullWidth
                    variant="standard"
                  />
                )
              }
            </InputMask>
            <InputMask mask="999.999.999-99" value={cpfEmpresa} onChange={(event) => {
              setCpfEmpresa(event.target.value);
            }}>
              {
                inputProps => (
                  <TextField
                    autoFocus
                    margin="dense"
                    id="cpf"
                    sx={{ width: 200, marginLeft: 2 }}
                    label="CPF"
                    fullWidth
                    variant="standard"
                  />
                )
              }
            </InputMask>

            <Button sx={{ marginTop: 3, marginLeft: 2 }} color="primary" onClick={clearModal}>Limpar</Button>
            <Button sx={{ marginTop: 3, marginLeft: 2 }} color="primary" onClick={findEmpresas}>Pesquisar</Button>
            <TabelaModal>
              <DataTable value={empresas}
                selection={empresaSelecionada}
                paginator rows={10}
                onSelectionChange={e =>
                  setEmpresaSelecionada(e.value)
                } dataKey="codemp"
                responsiveLayout="scroll"
              >
                <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                <Column field="codemp" header="Código"></Column>
                <Column field="nome" header="Nome"></Column>
                <Column field="cnpj" header="CNPJ"></Column>
                <Column field="cpf" header="CPF"></Column>
              </DataTable>
            </TabelaModal>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleCloseDialog}>Cancelar</Button>
            {empresas.length > 0 ?
              <Button color="primary" onClick={selecionarEmpresa}>Selecionar</Button>
              : null}
          </DialogActions>
        </Dialog>
      </>
    )
  }

  export default PesquisarBilhetes;